module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/contest_stats/nba/survive/2_points&3pointers-0e676c52c388eb8abae7a62ae78f33c8.svg";